import Vue from 'vue'

Vue.directive('myfocus', { // 自动获取input焦点
	inserted(el) {
		el.focus()
  }
})